import type { IMaterial } from '~/types/Material';

export interface Part extends IMaterial {
    quantity: number;
}

export const getBasePartId = (partId: string): string => {
    // Remove the last instance number (e.g., 'part-1-1' -> 'part-1')
    const lastDashIndex = partId.lastIndexOf('-');
    if (lastDashIndex > 0) {
        const beforeLastDash = partId.substring(0, lastDashIndex);
        const afterLastDash = partId.substring(lastDashIndex + 1);

        // Check if the part after last dash is a number
        if (/^\d+$/.test(afterLastDash)) {
            return beforeLastDash;
        }
    }

    // If no instance number found, return original ID
    return partId;
};

export const countPlacedParts = (part: Part, result: any) => {
    let count = 0;

    if (result && result.usedMaterials) {
        result.usedMaterials.forEach((material: any) => {
            if (material.children) {
                material.children.forEach((placedPart: any) => {
                    if (placedPart.id.startsWith(part.id + '-')) {
                        count++;
                    }
                });
            }
        });
    }

    return count;
};

export const createDefaultParts = (): Part[] => {
    return [
        {
            id: 'part-1',
            width: 30,
            height: 20,
            quantity: 10,
        },
        {
            id: 'part-2',
            width: 25,
            height: 15,
            quantity: 20,
        }
    ];
};

export const createPartInstance = (length: number): Part => {
    const newId = `part-${length + 1}`;
    return {
        id: newId,
        width: 30,
        height: 20,
        quantity: 10,
    };
};

export const expandPartsWithQuantity = (parts: Part[]): IMaterial[] => {
    const expandedParts: IMaterial[] = [];
    parts.forEach((part) => {
        for (let i = 0; i < part.quantity; i++) {
            expandedParts.push({
                ...part,
                id: `${part.id}-${i + 1}`,
            });
        }
    });
    return expandedParts;
};